import { render, staticRenderFns } from "./qualityenterprise2.vue?vue&type=template&id=2b15a52d&"
import script from "./qualityenterprise2.vue?vue&type=script&lang=js&"
export * from "./qualityenterprise2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports